import { Box, IconButton, Typography } from "@mui/material";
import { ReactNode, useState } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import ChevronDown from "~frontend/components/icons/ChevronDown";
import ChevronUp from "~frontend/components/icons/ChevronUp";
import { palette } from "~frontend/theme";

export const CollapsibleContainer = ({
  children,
  header,
  headerActions,
}: {
  children: ReactNode;
  header: string;
  headerActions?: ReactNode | ReactNode[];
}): ReactNode => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Box
      sx={{
        py: 2,
        pl: 5,
        pr: 2.5,
        backgroundColor: palette.white,
        width: "100%",
      }}
    >
      <FlexBox
        justifyContent="space-between"
        alignItems="center"
        sx={{ pb: collapsed ? 0 : 2 }}
      >
        <Typography variant="h2Bold">{header}</Typography>
        <FlexBox gap={1.25}>
          {headerActions}
          <IconButton onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? <ChevronDown /> : <ChevronUp />}
          </IconButton>
        </FlexBox>
      </FlexBox>

      {collapsed ? null : <Box sx={{ pb: 2, pr: 5 }}>{children}</Box>}
    </Box>
  );
};
